import companyLicenseApiService from "../../api/raily/company-license/company-license-api.service";
import CompanyLicenseStatusResponse from "../../api/raily/company-license/status/company-license-status.response";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";

const getCompanyLicenseStatus = async (
  abortSignal: AbortSignal,
): Promise<boolean> => {
  try {
    const response: CompanyLicenseStatusResponse =
      await companyLicenseApiService().getCompanyLicenseStatus(abortSignal);

    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const companyLicenseService = {
  getCompanyLicenseStatus,
};

export default companyLicenseService;
